import { IEmployee } from "Dashboard/scenes/HumanResources/domain/IEmployee";
import { ChangeEvent, useEffect, useState } from "react";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { IFuelSearch } from "Dashboard/scenes/HumanResources/domain/IFuelSearch";
import { IFuel } from "Dashboard/scenes/HumanResources/domain/IFuel";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import MonthSelect from "Dashboard/components/MonthSelect";

interface IProps {
  employee: IEmployee;
}

const Fuel = ({ employee }: IProps) => {
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [fuel, setFuel] = useState<IFuel[]>([]);
  const [totalQuantity, setTotalQuantity] = useState<number>();
  const [totalValue, setTotalValue] = useState<number>();

  useEffect(() => {
    const getFuel = async (data: IFuelSearch) => {
      try {
        let fuels = await hrService.getAllEmployeeRefuels(data);
        setFuel(fuels.refuels);
        setTotalQuantity(fuels.totalQuantity);
        setTotalValue(fuels.totalValue);
      } catch (err) {
        console.log(err);
      }
    };

    if (employee) {
      var date = new Date();
      var from = FormatDateIso(new Date(date.getFullYear(), month - 1, 1));
      var to = FormatDateIso(new Date(date.getFullYear(), month, 0));
      getFuel({ employeeId: employee.employeeId, from, to });
    }
  }, [month, employee]);

  return (
    <div className="gas-info">
      <div className="selectable-headline">
        <span>Gorivo</span>
        <MonthSelect
          defaultValue={month}
          name="months"
          onChange={(e: ChangeEvent<HTMLSelectElement>) => {
            setMonth(Number(e.target.value));
          }}
        />
      </div>
      <div className="additional-container">
        {fuel.length > 0 &&
          fuel.map((f, index) => (
            <div className="" key={index}>
              <div className="hr-fuel-card" >
                <span className="data-cell">{FormatNumberWithUnitOrNull(f.quantityAmount, f.quantityUnit.name)}</span>
                <span className="data-cell data-cell-wide">{FormatNumberWithUnitOrNull(f.totalValue, 'rsd')}</span>
                <span className="date-cell">{FormatDateShort(f.date)}</span>
              </div>
              <span className="note-cell">{f.note}</span>
            </div>
          ))}
      </div>
      <div className="additional-sum">
        Ukupno: <span className="count-cell">{FormatNumberWithUnitOrNull(totalQuantity, 'L')}</span>
        <span className="value-cell">{FormatNumberWithUnitOrNull(totalValue, 'rsd')}</span>
      </div>
    </div>
  );
};

export default Fuel;
